import notifier from "./index"

const onLoad = () => {
  notifier.onPageLoad()
}

export default onLoad
